/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Constants from './Constants';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { getServiceUrlandE2eRequestId, GetProcessStepPages, GetCurrentPageName, enablePegaProcessSteps } from '../../components/common/Helpers/index';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
// import { getErrorLogObj } from '../../services/loggerService';
// import { getSecureBaseUrl } from '../../services/UrlMapperService';
// import { apiUrls } from '../../constants/apiUrl';
// import { getCartDetails } from '../../services/Cart/actions';

function* getPlans({ data }) {
  let errorSetup = false;
  let serviceDetails = null;
  // yield put({ type: Constants.ERR_OCCURED, errorSetup });
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(Actions.getPlansDev, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_PLANS_SUCCESS, response: apiResponse.data });
    } else {
      // logError('getPlans', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        errorSetup = true;

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getPlans ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        serviceDetails = getServiceUrlandE2eRequestId('getPlans from devicesetup saga', apiResponse);
      }
      yield put({ type: Constants.ERR_OCCURED, errorSetup, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error && error.response) {
      errorSetup = true;
      serviceDetails = {
        method: 'getPlans from devicesetup saga',
      };
      yield put({ type: Constants.ERR_OCCURED, errorSetup, serviceinfo: serviceDetails });
    }
    // logError('getPlans', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* setupUpdate(data) {
  // ('HELLO')
  let errorSetup = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorSetup });
  // yield put({ type: Constants.ASYNC_FETCH });
  if (data) {
    // const apiResponse = yield call(Actions.getPlansAem, data);
    yield put({});
    yield put({ type: 'SAVE_SELECTED_SETUP_OPTION', response: data });
    // yield invokeTagging('cpc-selected_plan');
  } else {
    errorSetup = true;
    serviceDetails = {
      method: 'setupUpdate',
    };
    yield put({ type: Constants.ERR_OCCURED, errorSetup, serviceinfo: serviceDetails });
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* optionSelected(data) {
  if (data) {
    yield put({ type: 'UPDATE_SELECTED_OPTION', response: data });
  } else {
    yield put({ type: Constants.ERR_OCCURED });
  }
}

function* hideMessageBar() {
  yield put(notificationActions.hideNotification());
}

function* updateProcessStepSetup(data) {
  let errorSetup = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorSetup });
  yield put({ type: Constants.CEF_DEVICE_SETUP_ERROR, errorSetup, errorMessage: null });
  yield put({ type: 'DEVICE_SETUP_ERROR', response: false });
  yield put({ type: Constants.ASYNC_FETCH });

  try {
    showLoader();
    const apiResponseProcessStep = yield call(Actions.updateProcessStepApi, data);
    if (apiResponseProcessStep && apiResponseProcessStep.data && !apiResponseProcessStep.data.errors) {
      if (enablePegaProcessSteps() && apiResponseProcessStep?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep) {
        const processStep = GetProcessStepPages(apiResponseProcessStep?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep);
        if (processStep && processStep !== '') {
          yield put({ type: 'NEXT_PROCESS_STEP', value: processStep });
        }
        const currentPageName = GetCurrentPageName();
        if (currentPageName) {
          yield put({ type: 'PREVIOUS_PROCESS_STEP', value: currentPageName });
        }
        if (data?.data) {
          yield put({ type: 'UPDATED_SETUP_PROCESSSTEP', value: true });
        } 
      }
      hideLoader();
    } else if (apiResponseProcessStep && apiResponseProcessStep.data && apiResponseProcessStep.data.errors) {
      yield put({ type: 'DEVICE_SETUP_ERROR', response: true });
      hideLoader();
    }
  } catch (error) {
    if (error && error.response) {
      errorSetup = true;
    }
    hideLoader();
    serviceDetails = {
      method: 'setupUpdate',
    };
    yield put({ type: Constants.ERR_OCCURED, errorSetup, serviceinfo: serviceDetails });
    yield put({ type: Constants.CEF_DEVICE_SETUP_ERROR, errorSetup, errorMessage: 'Looks like something went wrong. Please try again later.' });
    // logError('updateProcessStepSetup', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  // yield takeLatest(Constants.GET_PLANS_FROM_AEM, getPlanReferenceData);
  yield takeLatest(Constants.GET_PLANS_FROM_API, getPlans);
  yield takeLatest('SAVE_SELECTED_SETUP_OPTION', setupUpdate);
  yield takeLatest('OPTION_SELECTED', optionSelected);
  yield takeLatest(Constants.HIDE_NOTIFICATION_BAR, hideMessageBar);
  yield takeLatest(Constants.UPDATE_PROCESS_STEP_SETUP, updateProcessStepSetup);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
